export const finalPrice = (
  shippingCost,
  collectionService,
  addShippingToCollectionValue,
  collectionCommissionWithRate,
  collectionCommissionWithOutRate,
) => {
  if (collectionService) {
    if (addShippingToCollectionValue) {
      return collectionCommissionWithRate + shippingCost;
    }
    return collectionCommissionWithOutRate + shippingCost;
  }
  return shippingCost;
};

export const collectionServiceValue = (
  saleValue,
  shippingCost,
  collectionService,
  addShippingToCollectionValue,
  collectionCommissionWithRate,
  collectionCommissionWithOutRate,
) => {
  if (collectionService && saleValue) {
    if (addShippingToCollectionValue) {
      return finalPrice(
        shippingCost,
        collectionService,
        addShippingToCollectionValue,
        collectionCommissionWithRate,
        collectionCommissionWithOutRate,
      ) + saleValue;
    }
    return saleValue;
  }
  return 0;
};

export const collectionServiceCommision = (
  collectionService,
  addShippingToCollectionValue,
  collectionCommissionWithRate,
  collectionCommissionWithOutRate,
) => {
  if (collectionService) {
    if (addShippingToCollectionValue) {
      return collectionCommissionWithRate;
    }
    return collectionCommissionWithOutRate;
  }
  return 0;
};

export default {
  finalPrice,
};
